// utils/uploadToCloudinary.js
export const uploadToCloudinary = async (file) => {
  const url = `https://api.cloudinary.com/v1_1/dzlylm2jy/upload`;
  const formData = new FormData();

  formData.append("file", file);
  formData.append("upload_preset", "user_pets"); // твой preset

  const res = await fetch(url, {
    method: "POST",
    body: formData,
  });

  if (!res.ok) {
    throw new Error("Failed to upload image");
  }

  const data = await res.json();
  return data.secure_url; // вот это мы сохраняем в Firebase
};
